export default {
    namespaced: true,
    state: {
        active: false,
        checked: false,
        text: '',
    },
    mutations: {
        INIT (state, config) {
            state.active = config.enabled;
            state.text = config.text;
        },
        SET (state, checked) {
            state.checked = checked;
        },
    }
}